module.exports = __webpack_public_path__ + "resources/img/equipment_tab_img2_m.a70372adc6759026bf4761959c7eaf82.jpg";